import { render, staticRenderFns } from "./HierarquiaUnidadeAdministrativaList.vue?vue&type=template&id=852a6ed6"
import script from "./HierarquiaUnidadeAdministrativaList.vue?vue&type=script&lang=js"
export * from "./HierarquiaUnidadeAdministrativaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports